import { CommercialEvaluationRepository } from '@src/main/modules/reports/commercial/domain/commercial-evaluation.repository';

export const downloadCommercialEvaluationPdf = async (
  repository: CommercialEvaluationRepository,
  evaluationId: string,
): Promise<Blob> => await repository.downloadPdf(evaluationId);
